import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { TipoCuentaBancariaDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class TipoCuentaBancariaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getTipoCuentaBancariaService(): Observable<BodyListResponse<TipoCuentaBancariaDTO>> {
    return this.http.get<BodyListResponse<TipoCuentaBancariaDTO>>(API_URL + '/api/v1/tipoCuentaBancaria/todos');
  }

  guardarTipoCuentaBancariaService(tipoCuentaBancariaDTO: TipoCuentaBancariaDTO): Observable<TipoCuentaBancariaDTO> {
    return this.http.post<TipoCuentaBancariaDTO>(API_URL + '/api/v1/tipoCuentaBancaria', tipoCuentaBancariaDTO);
  }

  getTipoCuentaBancariaPorCodigoTipoCuentaBancariaService(codigoTipoCuentaBancaria: string): Observable<BodyResponse<TipoCuentaBancariaDTO>> {
    return this.http.get<BodyResponse<TipoCuentaBancariaDTO>>(API_URL + '/api/v1/tipoCuentaBancaria/' + codigoTipoCuentaBancaria);
  }
}
